import React, { useEffect, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Form, Col } from 'react-bootstrap'
import { AuthContext } from '../contexts/AuthContext'

const CitySelect = ({ citys, selectedCity, onChange }) => {
  const { t } = useTranslation()
  const { isAdmin } = useContext(AuthContext)
  const [cityOptions, setCityOptions] = useState([])

  useEffect(() => {
    if (isAdmin) {
      setCityOptions(citys)
    } else {
      const citysFromStorage = JSON.parse(localStorage.getItem('citys')) || []
      const filteredCityOptions = citys.filter((city) =>
        citysFromStorage.includes(city.name),
      )
      setCityOptions(filteredCityOptions)
    }
  }, [citys, isAdmin])

  useEffect(() => {
    if (!selectedCity && cityOptions.length > 0) {
      onChange(cityOptions[0].name)
    }
  }, [cityOptions, onChange, selectedCity])

  const handleSelectChange = (event) => {
    if (onChange) {
      onChange(event.target.value)
    }
  }

  return (
    <Form.Group as={Col} controlId="citySelect">
      <Form.Label>{t('VILLAGE')}</Form.Label>
      <Form.Control
        as="select"
        value={selectedCity}
        onChange={handleSelectChange}
      >
        {cityOptions.map((option) => (
          <option key={option.name} value={option.name}>
            {option.label}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  )
}

CitySelect.propTypes = {
  citys: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedCity: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default CitySelect
